import { put, call, takeLatest } from "redux-saga/effects";
import services from "../../services";

import {
  REGISTER_VIEW,
  REGISTER_VIEW_SUCCESS,
  REGISTER_VIEW_ERROR,
} from "../types/post-views/register-view";

import {
  GET_POST_METRICS,
  GET_POST_METRICS_SUCCESS,
  GET_POST_METRICS_ERROR,
} from "../types/post-views/get-metrics";

import {
  GET_POST_INCREMENT,
  GET_POST_INCREMENT_SUCCESS,
  GET_POST_INCREMENT_ERROR,
} from "../types/post-views/get-increment";

import {
  GET_POST_TIME_SERIES,
  GET_POST_TIME_SERIES_SUCCESS,
  GET_POST_TIME_SERIES_ERROR,
} from "../types/post-views/get-time-series";

import {
  GET_SUBSCRIBER_VIEWS,
  GET_SUBSCRIBER_VIEWS_SUCCESS,
  GET_SUBSCRIBER_VIEWS_ERROR,
} from "../types/post-views/get-subscriber-views";

/**
 * Registrar vista
 */
function* registerView({ payload }): any {
  try {
    const { response, error } = yield call(services.postViews.registerView, payload);

    if (error) {
      yield put({ type: REGISTER_VIEW_ERROR, payload: error });
    } else {
      yield put({ type: REGISTER_VIEW_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({
      type: REGISTER_VIEW_ERROR,
      payload: "Error inesperado al registrar vista.",
    });
  }
}

/**
 * Obtener métricas de un post
 */
function* getPostMetrics({ payload }): any {
  try {
    const { response, error } = yield call(services.postViews.getMetrics, payload);

    if (error) {
      yield put({ type: GET_POST_METRICS_ERROR, payload: error });
    } else {
      yield put({ type: GET_POST_METRICS_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({
      type: GET_POST_METRICS_ERROR,
      payload: "Error inesperado al obtener métricas.",
    });
  }
}

/**
 * Obtener incremento de vistas
 */
function* getPostIncrement({ payload }): any {
  try {
    const { response, error } = yield call(services.postViews.getIncrement, payload);

    if (error) {
      yield put({ type: GET_POST_INCREMENT_ERROR, payload: error });
    } else {
      yield put({ type: GET_POST_INCREMENT_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({
      type: GET_POST_INCREMENT_ERROR,
      payload: "Error inesperado al obtener incremento.",
    });
  }
}

/**
 * Obtener serie temporal
 */
function* getPostTimeSeries({ payload }): any {
  try {
    const { response, error } = yield call(services.postViews.getTimeSeries, payload);

    if (error) {
      yield put({ type: GET_POST_TIME_SERIES_ERROR, payload: error });
    } else {
      yield put({ type: GET_POST_TIME_SERIES_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({
      type: GET_POST_TIME_SERIES_ERROR,
      payload: "Error inesperado al obtener serie temporal.",
    });
  }
}

/**
 * Obtener vistas por suscriptor
 */
function* getSubscriberViews({ payload }): any {
  try {
    const { response, error } = yield call(services.postViews.getViewsBySubscriber, payload);

    if (error) {
      yield put({ type: GET_SUBSCRIBER_VIEWS_ERROR, payload: error });
    } else {
      yield put({ type: GET_SUBSCRIBER_VIEWS_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({
      type: GET_SUBSCRIBER_VIEWS_ERROR,
      payload: "Error inesperado al obtener vistas del suscriptor.",
    });
  }
}

/**
 * Watchers
 */
export default function* postViewsSaga() {
  yield takeLatest<any>(REGISTER_VIEW, registerView);
  yield takeLatest<any>(GET_POST_METRICS, getPostMetrics);
  yield takeLatest<any>(GET_POST_INCREMENT, getPostIncrement);
  yield takeLatest<any>(GET_POST_TIME_SERIES, getPostTimeSeries);
  yield takeLatest<any>(GET_SUBSCRIBER_VIEWS, getSubscriberViews);
}

